export default {
  list: [
    {
      value: 'REQUESTED',
      title: 'درخواست تایید'
    },
    {
      value: 'CONFIRMED',
      title: 'تایید شده'
    },
    {
      value: 'REJECTED',
      title: 'رد شده'
    },
    {
      value: 'DISABLED',
      title: 'غیرفعال'
    }
  ],
  values: {
    REQUESTED: 'REQUESTED',
    CONFIRMED: 'CONFIRMED',
    REJECTED: 'REJECTED',
    DISABLED: 'DISABLED',
  }
}